/**
 * @generated SignedSource<<fd21a2ec7780cffe043c2f42cd52a914>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type requestType_nativeIssueTable_RequestTypeCell$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly requestType: {
    readonly avatar: {
      readonly xsmall: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "requestType_nativeIssueTable_RequestTypeCell";
};
export type requestType_nativeIssueTable_RequestTypeCell$key = {
  readonly " $data"?: requestType_nativeIssueTable_RequestTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestType_nativeIssueTable_RequestTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "requestType_nativeIssueTable_RequestTypeCell",
  "selections": [
    {
      "concreteType": "JiraServiceManagementRequestType",
      "kind": "LinkedField",
      "name": "requestType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "xsmall"
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraServiceManagementRequestTypeField"
};

(node as any).hash = "ad49a74d0d1261be7f3c245bb370c16d";

export default node;
